module.exports = __webpack_public_path__ + "img/logo-new-full-alternate.ca0b596e.png";